export const ANGULAR_SUPPORTED_LOCALES = [ 'af', 'af-NA', 'agq', 'ak', 'am', 'ar-AE', 'ar-BH', 'ar-DJ', 'ar-DZ', 'ar-EG', 'ar-EH', 'ar-ER', 'ar-IL', 'ar-IQ', 'ar-JO', 'ar', 'ar-KM', 'ar-KW', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-MR', 'ar-OM', 'ar-PS', 'ar-QA', 'ar-SA', 'ar-SD', 'ar-SO', 'ar-SS', 'ar-SY', 'ar-TD', 'ar-TN', 'ar-YE', 'asa', 'as', 'ast', 'az-Cyrl', 'az', 'az-Latn', 'bas', 'be', 'bem', 'bez', 'bg', 'bm', 'bn-IN', 'bn', 'bo-IN', 'bo', 'br', 'brx', 'bs-Cyrl', 'bs', 'bs-Latn', 'ca-AD', 'ca-FR', 'ca-IT', 'ca', 'ccp-IN', 'ccp', 'ceb', 'ce', 'cgg', 'chr', 'ckb-IR', 'ckb', 'cs', 'cy', 'da-GL', 'da', 'dav', 'de-AT', 'de-BE', 'de-CH', 'de-IT', 'de', 'de-LI', 'de-LU', 'dje', 'doi', 'dsb', 'dua', 'dyo', 'dz', 'ebu', 'ee', 'ee-TG', 'el-CY', 'el', 'en-001', 'en-150', 'en-AE', 'en-AG', 'en-AI', 'en-AS', 'en-AT', 'en-AU', 'en-BB', 'en-BE', 'en-BI', 'en-BM', 'en-BS', 'en-BW', 'en-BZ', 'en-CA', 'en-CC', 'en-CH', 'en-CK', 'en-CM', 'en-CX', 'en-CY', 'en-DE', 'en-DG', 'en-DK', 'en-DM', 'en-ER', 'en-FI', 'en-FJ', 'en-FK', 'en-FM', 'en-GB', 'en-GD', 'en-GG', 'en-GH', 'en-GI', 'en-GM', 'en-GU', 'en-GY', 'en-HK', 'en-IE', 'en-IL', 'en-IM', 'en-IN', 'en-IO', 'en-JE', 'en-JM', 'en', 'en-KE', 'en-KI', 'en-KN', 'en-KY', 'en-LC', 'en-LR', 'en-LS', 'en-MG', 'en-MH', 'en-MO', 'en-MP', 'en-MS', 'en-MT', 'en-MU', 'en-MW', 'en-MY', 'en-NA', 'en-NF', 'en-NG', 'en-NL', 'en-NR', 'en-NU', 'en-NZ', 'en-PG', 'en-PH', 'en-PK', 'en-PN', 'en-PR', 'en-PW', 'en-RW', 'en-SB', 'en-SC', 'en-SD', 'en-SE', 'en-SG', 'en-SH', 'en-SI', 'en-SL', 'en-SS', 'en-SX', 'en-SZ', 'en-TC', 'en-TK', 'en-TO', 'en-TT', 'en-TV', 'en-TZ', 'en-UG', 'en-UM', 'en-VC', 'en-VG', 'en-VI', 'en-VU', 'en-WS', 'en-ZA', 'en-ZM', 'en-ZW', 'eo', 'es-419', 'es-AR', 'es-BO', 'es-BR', 'es-BZ', 'es-CL', 'es-CO', 'es-CR', 'es-CU', 'es-DO', 'es-EA', 'es-EC', 'es-GQ', 'es-GT', 'es-HN', 'es-IC', 'es', 'es-MX', 'es-NI', 'es-PA', 'es-PE', 'es-PH', 'es-PR', 'es-PY', 'es-SV', 'es-US', 'es-UY', 'es-VE', 'et', 'eu', 'ewo', 'fa-AF', 'fa', 'ff-Adlm-BF', 'ff-Adlm-CM', 'ff-Adlm-GH', 'ff-Adlm-GM', 'ff-Adlm-GW', 'ff-Adlm', 'ff-Adlm-LR', 'ff-Adlm-MR', 'ff-Adlm-NE', 'ff-Adlm-NG', 'ff-Adlm-SL', 'ff-Adlm-SN', 'ff-CM', 'ff-GN', 'ff', 'ff-Latn-BF', 'ff-Latn-CM', 'ff-Latn-GH', 'ff-Latn-GM', 'ff-Latn-GN', 'ff-Latn-GW', 'ff-Latn', 'ff-Latn-LR', 'ff-Latn-MR', 'ff-Latn-NE', 'ff-Latn-NG', 'ff-Latn-SL', 'ff-MR', 'fi', 'fil', 'fo-DK', 'fo', 'fr-BE', 'fr-BF', 'fr-BI', 'fr-BJ', 'fr-BL', 'fr-CA', 'fr-CD', 'fr-CF', 'fr-CG', 'fr-CH', 'fr-CI', 'fr-CM', 'fr-DJ', 'fr-DZ', 'fr-GA', 'fr-GF', 'fr-GN', 'fr-GP', 'fr-GQ', 'fr-HT', 'fr', 'fr-KM', 'fr-LU', 'fr-MA', 'fr-MC', 'fr-MF', 'fr-MG', 'fr-ML', 'fr-MQ', 'fr-MR', 'fr-MU', 'fr-NC', 'fr-NE', 'fr-PF', 'fr-PM', 'fr-RE', 'fr-RW', 'fr-SC', 'fr-SN', 'fr-SY', 'fr-TD', 'fr-TG', 'fr-TN', 'fr-VU', 'fr-WF', 'fr-YT', 'fur', 'fy', 'ga-GB', 'ga', 'gd', 'gl', 'gsw-FR', 'gsw', 'gsw-LI', 'gu', 'guz', 'gv', 'ha-GH', 'ha', 'ha-NE', 'haw', 'he', 'hi', 'hr-BA', 'hr', 'hsb', 'hu', 'hy', 'ia', 'id', 'ig', 'ii', 'is', 'it-CH', 'it', 'it-SM', 'it-VA', 'ja', 'jgo', 'jmc', 'jv', 'kab', 'ka', 'kam', 'kde', 'kea', 'khq', 'ki', 'kkj', 'kk', 'kl', 'kln', 'km', 'kn', 'ko', 'kok', 'ko-KP', 'ks-Arab', 'ksb', 'ksf', 'ksh', 'ks', 'ku', 'kw', 'ky', 'lag', 'lb', 'lg', 'lkt', 'ln-AO', 'ln-CF', 'ln-CG', 'ln', 'lo', 'lrc-IQ', 'lrc', 'lt', 'lu', 'luo', 'luy', 'lv', 'mai', 'mas', 'mas-TZ', 'mer', 'mfe', 'mgh', 'mg', 'mgo', 'mi', 'mk', 'ml', 'mni-Beng', 'mni', 'mn', 'mr', 'ms-BN', 'ms-ID', 'ms', 'ms-SG', 'mt', 'mua', 'my', 'mzn', 'naq', 'nb', 'nb-SJ', 'nd', 'nds', 'nds-NL', 'ne-IN', 'ne', 'nl-AW', 'nl-BE', 'nl-BQ', 'nl-CW', 'nl', 'nl-SR', 'nl-SX', 'nmg', 'nnh', 'nn', 'no', 'nus', 'nyn', 'om', 'om-KE', 'or', 'os', 'os-RU', 'pa-Arab', 'pa-Guru', 'pa', 'pcm', 'pl', 'ps', 'ps-PK', 'pt-AO', 'pt-CH', 'pt-CV', 'pt-GQ', 'pt-GW', 'pt', 'pt-LU', 'pt-MO', 'pt-MZ', 'pt-PT', 'pt-ST', 'pt-TL', 'qu-BO', 'qu-EC', 'qu', 'rm', 'rn', 'rof', 'ro', 'ro-MD', 'ru-BY', 'ru', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-UA', 'rw', 'rwk', 'sah', 'sa', 'saq', 'sat', 'sat-Olck', 'sbp', 'sd-Arab', 'sd-Deva', 'sd', 'se-FI', 'seh', 'se', 'se-SE', 'ses', 'sg', 'shi', 'shi-Latn', 'shi-Tfng', 'si', 'sk', 'sl', 'smn', 'sn', 'so-DJ', 'so-ET', 'so', 'so-KE', 'sq', 'sq-MK', 'sq-XK', 'sr-Cyrl-BA', 'sr-Cyrl', 'sr-Cyrl-ME', 'sr-Cyrl-XK', 'sr', 'sr-Latn-BA', 'sr-Latn', 'sr-Latn-ME', 'sr-Latn-XK', 'su', 'su-Latn', 'sv-AX', 'sv-FI', 'sv', 'sw-CD', 'sw', 'sw-KE', 'sw-UG', 'ta', 'ta-LK', 'ta-MY', 'ta-SG', 'te', 'teo', 'teo-KE', 'tg', 'th', 'ti-ER', 'ti', 'tk', 'to', 'tr-CY', 'tr', 'tt', 'twq', 'tzm', 'ug', 'uk', 'ur-IN', 'ur', 'uz-Arab', 'uz-Cyrl', 'uz', 'uz-Latn', 'vai', 'vai-Latn', 'vai-Vaii', 'vi', 'vun', 'wae', 'wo', 'xh', 'xog', 'yav', 'yi', 'yo-BJ', 'yo', 'yue-Hans', 'yue-Hant', 'yue', 'zgh', 'zh-Hans-HK', 'zh-Hans', 'zh-Hans-MO', 'zh-Hans-SG', 'zh-Hant-HK', 'zh-Hant', 'zh-Hant-MO', 'zh', 'zu' ] as const
export type AngularSupportedLocale = typeof ANGULAR_SUPPORTED_LOCALES[number]

export const isSupportedLocale = (localeId: string): localeId is AngularSupportedLocale =>
  (ANGULAR_SUPPORTED_LOCALES as unknown as string[]).includes(localeId)

export const safeGetBrowserPreference: () => string
  = () => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().locale
    } catch {
      return 'en'
    }
  }

export const fromBrowserPreference = (): AngularSupportedLocale => {
  // try to get browser perferrence, if browser doesn't provide the information use en as fallback
  const browserPreference = safeGetBrowserPreference()
  // if it is an angular supported locale, use it
  if (isSupportedLocale(browserPreference)){
    return browserPreference
  }
  // if not extract the language code and if the default locale for this language is an angular suported locale, use it
  const browserPreferenceLanguageCode = browserPreference.split('-')[0]
  if (isSupportedLocale(browserPreferenceLanguageCode)){
    return browserPreferenceLanguageCode
  }
  // if nothing works, fallback to en
  return 'en'
}

export const loadData = async (localeId:AngularSupportedLocale):Promise<void> => {
  switch (localeId) {
    case 'af': {
      import('@angular/common/locales/global/af')
      return
    }
    case 'af-NA': {
      import('@angular/common/locales/global/af-NA')
      return
    }
    case 'agq': {
      import('@angular/common/locales/global/agq')
      return
    }
    case 'ak': {
      import('@angular/common/locales/global/ak')
      return
    }
    case 'am': {
      import('@angular/common/locales/global/am')
      return
    }
    case 'ar-AE': {
      import('@angular/common/locales/global/ar-AE')
      return
    }
    case 'ar-BH': {
      import('@angular/common/locales/global/ar-BH')
      return
    }
    case 'ar-DJ': {
      import('@angular/common/locales/global/ar-DJ')
      return
    }
    case 'ar-DZ': {
      import('@angular/common/locales/global/ar-DZ')
      return
    }
    case 'ar-EG': {
      import('@angular/common/locales/global/ar-EG')
      return
    }
    case 'ar-EH': {
      import('@angular/common/locales/global/ar-EH')
      return
    }
    case 'ar-ER': {
      import('@angular/common/locales/global/ar-ER')
      return
    }
    case 'ar-IL': {
      import('@angular/common/locales/global/ar-IL')
      return
    }
    case 'ar-IQ': {
      import('@angular/common/locales/global/ar-IQ')
      return
    }
    case 'ar-JO': {
      import('@angular/common/locales/global/ar-JO')
      return
    }
    case 'ar': {
      import('@angular/common/locales/global/ar')
      return
    }
    case 'ar-KM': {
      import('@angular/common/locales/global/ar-KM')
      return
    }
    case 'ar-KW': {
      import('@angular/common/locales/global/ar-KW')
      return
    }
    case 'ar-LB': {
      import('@angular/common/locales/global/ar-LB')
      return
    }
    case 'ar-LY': {
      import('@angular/common/locales/global/ar-LY')
      return
    }
    case 'ar-MA': {
      import('@angular/common/locales/global/ar-MA')
      return
    }
    case 'ar-MR': {
      import('@angular/common/locales/global/ar-MR')
      return
    }
    case 'ar-OM': {
      import('@angular/common/locales/global/ar-OM')
      return
    }
    case 'ar-PS': {
      import('@angular/common/locales/global/ar-PS')
      return
    }
    case 'ar-QA': {
      import('@angular/common/locales/global/ar-QA')
      return
    }
    case 'ar-SA': {
      import('@angular/common/locales/global/ar-SA')
      return
    }
    case 'ar-SD': {
      import('@angular/common/locales/global/ar-SD')
      return
    }
    case 'ar-SO': {
      import('@angular/common/locales/global/ar-SO')
      return
    }
    case 'ar-SS': {
      import('@angular/common/locales/global/ar-SS')
      return
    }
    case 'ar-SY': {
      import('@angular/common/locales/global/ar-SY')
      return
    }
    case 'ar-TD': {
      import('@angular/common/locales/global/ar-TD')
      return
    }
    case 'ar-TN': {
      import('@angular/common/locales/global/ar-TN')
      return
    }
    case 'ar-YE': {
      import('@angular/common/locales/global/ar-YE')
      return
    }
    case 'asa': {
      import('@angular/common/locales/global/asa')
      return
    }
    case 'as': {
      import('@angular/common/locales/global/as')
      return
    }
    case 'ast': {
      import('@angular/common/locales/global/ast')
      return
    }
    case 'az-Cyrl': {
      import('@angular/common/locales/global/az-Cyrl')
      return
    }
    case 'az': {
      import('@angular/common/locales/global/az')
      return
    }
    case 'az-Latn': {
      import('@angular/common/locales/global/az-Latn')
      return
    }
    case 'bas': {
      import('@angular/common/locales/global/bas')
      return
    }
    case 'be': {
      import('@angular/common/locales/global/be')
      return
    }
    case 'bem': {
      import('@angular/common/locales/global/bem')
      return
    }
    case 'bez': {
      import('@angular/common/locales/global/bez')
      return
    }
    case 'bg': {
      import('@angular/common/locales/global/bg')
      return
    }
    case 'bm': {
      import('@angular/common/locales/global/bm')
      return
    }
    case 'bn-IN': {
      import('@angular/common/locales/global/bn-IN')
      return
    }
    case 'bn': {
      import('@angular/common/locales/global/bn')
      return
    }
    case 'bo-IN': {
      import('@angular/common/locales/global/bo-IN')
      return
    }
    case 'bo': {
      import('@angular/common/locales/global/bo')
      return
    }
    case 'br': {
      import('@angular/common/locales/global/br')
      return
    }
    case 'brx': {
      import('@angular/common/locales/global/brx')
      return
    }
    case 'bs-Cyrl': {
      import('@angular/common/locales/global/bs-Cyrl')
      return
    }
    case 'bs': {
      import('@angular/common/locales/global/bs')
      return
    }
    case 'bs-Latn': {
      import('@angular/common/locales/global/bs-Latn')
      return
    }
    case 'ca-AD': {
      import('@angular/common/locales/global/ca-AD')
      return
    }
    case 'ca-FR': {
      import('@angular/common/locales/global/ca-FR')
      return
    }
    case 'ca-IT': {
      import('@angular/common/locales/global/ca-IT')
      return
    }
    case 'ca': {
      import('@angular/common/locales/global/ca')
      return
    }
    case 'ccp-IN': {
      import('@angular/common/locales/global/ccp-IN')
      return
    }
    case 'ccp': {
      import('@angular/common/locales/global/ccp')
      return
    }
    case 'ceb': {
      import('@angular/common/locales/global/ceb')
      return
    }
    case 'ce': {
      import('@angular/common/locales/global/ce')
      return
    }
    case 'cgg': {
      import('@angular/common/locales/global/cgg')
      return
    }
    case 'chr': {
      import('@angular/common/locales/global/chr')
      return
    }
    case 'ckb-IR': {
      import('@angular/common/locales/global/ckb-IR')
      return
    }
    case 'ckb': {
      import('@angular/common/locales/global/ckb')
      return
    }
    case 'cs': {
      import('@angular/common/locales/global/cs')
      return
    }
    case 'cy': {
      import('@angular/common/locales/global/cy')
      return
    }
    case 'da-GL': {
      import('@angular/common/locales/global/da-GL')
      return
    }
    case 'da': {
      import('@angular/common/locales/global/da')
      return
    }
    case 'dav': {
      import('@angular/common/locales/global/dav')
      return
    }
    case 'de-AT': {
      import('@angular/common/locales/global/de-AT')
      return
    }
    case 'de-BE': {
      import('@angular/common/locales/global/de-BE')
      return
    }
    case 'de-CH': {
      import('@angular/common/locales/global/de-CH')
      return
    }
    case 'de-IT': {
      import('@angular/common/locales/global/de-IT')
      return
    }
    case 'de': {
      import('@angular/common/locales/global/de')
      return
    }
    case 'de-LI': {
      import('@angular/common/locales/global/de-LI')
      return
    }
    case 'de-LU': {
      import('@angular/common/locales/global/de-LU')
      return
    }
    case 'dje': {
      import('@angular/common/locales/global/dje')
      return
    }
    case 'doi': {
      import('@angular/common/locales/global/doi')
      return
    }
    case 'dsb': {
      import('@angular/common/locales/global/dsb')
      return
    }
    case 'dua': {
      import('@angular/common/locales/global/dua')
      return
    }
    case 'dyo': {
      import('@angular/common/locales/global/dyo')
      return
    }
    case 'dz': {
      import('@angular/common/locales/global/dz')
      return
    }
    case 'ebu': {
      import('@angular/common/locales/global/ebu')
      return
    }
    case 'ee': {
      import('@angular/common/locales/global/ee')
      return
    }
    case 'ee-TG': {
      import('@angular/common/locales/global/ee-TG')
      return
    }
    case 'el-CY': {
      import('@angular/common/locales/global/el-CY')
      return
    }
    case 'el': {
      import('@angular/common/locales/global/el')
      return
    }
    case 'en-001': {
      import('@angular/common/locales/global/en-001')
      return
    }
    case 'en-150': {
      import('@angular/common/locales/global/en-150')
      return
    }
    case 'en-AE': {
      import('@angular/common/locales/global/en-AE')
      return
    }
    case 'en-AG': {
      import('@angular/common/locales/global/en-AG')
      return
    }
    case 'en-AI': {
      import('@angular/common/locales/global/en-AI')
      return
    }
    case 'en-AS': {
      import('@angular/common/locales/global/en-AS')
      return
    }
    case 'en-AT': {
      import('@angular/common/locales/global/en-AT')
      return
    }
    case 'en-AU': {
      import('@angular/common/locales/global/en-AU')
      return
    }
    case 'en-BB': {
      import('@angular/common/locales/global/en-BB')
      return
    }
    case 'en-BE': {
      import('@angular/common/locales/global/en-BE')
      return
    }
    case 'en-BI': {
      import('@angular/common/locales/global/en-BI')
      return
    }
    case 'en-BM': {
      import('@angular/common/locales/global/en-BM')
      return
    }
    case 'en-BS': {
      import('@angular/common/locales/global/en-BS')
      return
    }
    case 'en-BW': {
      import('@angular/common/locales/global/en-BW')
      return
    }
    case 'en-BZ': {
      import('@angular/common/locales/global/en-BZ')
      return
    }
    case 'en-CA': {
      import('@angular/common/locales/global/en-CA')
      return
    }
    case 'en-CC': {
      import('@angular/common/locales/global/en-CC')
      return
    }
    case 'en-CH': {
      import('@angular/common/locales/global/en-CH')
      return
    }
    case 'en-CK': {
      import('@angular/common/locales/global/en-CK')
      return
    }
    case 'en-CM': {
      import('@angular/common/locales/global/en-CM')
      return
    }
    case 'en-CX': {
      import('@angular/common/locales/global/en-CX')
      return
    }
    case 'en-CY': {
      import('@angular/common/locales/global/en-CY')
      return
    }
    case 'en-DE': {
      import('@angular/common/locales/global/en-DE')
      return
    }
    case 'en-DG': {
      import('@angular/common/locales/global/en-DG')
      return
    }
    case 'en-DK': {
      import('@angular/common/locales/global/en-DK')
      return
    }
    case 'en-DM': {
      import('@angular/common/locales/global/en-DM')
      return
    }
    case 'en-ER': {
      import('@angular/common/locales/global/en-ER')
      return
    }
    case 'en-FI': {
      import('@angular/common/locales/global/en-FI')
      return
    }
    case 'en-FJ': {
      import('@angular/common/locales/global/en-FJ')
      return
    }
    case 'en-FK': {
      import('@angular/common/locales/global/en-FK')
      return
    }
    case 'en-FM': {
      import('@angular/common/locales/global/en-FM')
      return
    }
    case 'en-GB': {
      import('@angular/common/locales/global/en-GB')
      return
    }
    case 'en-GD': {
      import('@angular/common/locales/global/en-GD')
      return
    }
    case 'en-GG': {
      import('@angular/common/locales/global/en-GG')
      return
    }
    case 'en-GH': {
      import('@angular/common/locales/global/en-GH')
      return
    }
    case 'en-GI': {
      import('@angular/common/locales/global/en-GI')
      return
    }
    case 'en-GM': {
      import('@angular/common/locales/global/en-GM')
      return
    }
    case 'en-GU': {
      import('@angular/common/locales/global/en-GU')
      return
    }
    case 'en-GY': {
      import('@angular/common/locales/global/en-GY')
      return
    }
    case 'en-HK': {
      import('@angular/common/locales/global/en-HK')
      return
    }
    case 'en-IE': {
      import('@angular/common/locales/global/en-IE')
      return
    }
    case 'en-IL': {
      import('@angular/common/locales/global/en-IL')
      return
    }
    case 'en-IM': {
      import('@angular/common/locales/global/en-IM')
      return
    }
    case 'en-IN': {
      import('@angular/common/locales/global/en-IN')
      return
    }
    case 'en-IO': {
      import('@angular/common/locales/global/en-IO')
      return
    }
    case 'en-JE': {
      import('@angular/common/locales/global/en-JE')
      return
    }
    case 'en-JM': {
      import('@angular/common/locales/global/en-JM')
      return
    }
    case 'en': {
      import('@angular/common/locales/global/en')
      return
    }
    case 'en-KE': {
      import('@angular/common/locales/global/en-KE')
      return
    }
    case 'en-KI': {
      import('@angular/common/locales/global/en-KI')
      return
    }
    case 'en-KN': {
      import('@angular/common/locales/global/en-KN')
      return
    }
    case 'en-KY': {
      import('@angular/common/locales/global/en-KY')
      return
    }
    case 'en-LC': {
      import('@angular/common/locales/global/en-LC')
      return
    }
    case 'en-LR': {
      import('@angular/common/locales/global/en-LR')
      return
    }
    case 'en-LS': {
      import('@angular/common/locales/global/en-LS')
      return
    }
    case 'en-MG': {
      import('@angular/common/locales/global/en-MG')
      return
    }
    case 'en-MH': {
      import('@angular/common/locales/global/en-MH')
      return
    }
    case 'en-MO': {
      import('@angular/common/locales/global/en-MO')
      return
    }
    case 'en-MP': {
      import('@angular/common/locales/global/en-MP')
      return
    }
    case 'en-MS': {
      import('@angular/common/locales/global/en-MS')
      return
    }
    case 'en-MT': {
      import('@angular/common/locales/global/en-MT')
      return
    }
    case 'en-MU': {
      import('@angular/common/locales/global/en-MU')
      return
    }
    case 'en-MW': {
      import('@angular/common/locales/global/en-MW')
      return
    }
    case 'en-MY': {
      import('@angular/common/locales/global/en-MY')
      return
    }
    case 'en-NA': {
      import('@angular/common/locales/global/en-NA')
      return
    }
    case 'en-NF': {
      import('@angular/common/locales/global/en-NF')
      return
    }
    case 'en-NG': {
      import('@angular/common/locales/global/en-NG')
      return
    }
    case 'en-NL': {
      import('@angular/common/locales/global/en-NL')
      return
    }
    case 'en-NR': {
      import('@angular/common/locales/global/en-NR')
      return
    }
    case 'en-NU': {
      import('@angular/common/locales/global/en-NU')
      return
    }
    case 'en-NZ': {
      import('@angular/common/locales/global/en-NZ')
      return
    }
    case 'en-PG': {
      import('@angular/common/locales/global/en-PG')
      return
    }
    case 'en-PH': {
      import('@angular/common/locales/global/en-PH')
      return
    }
    case 'en-PK': {
      import('@angular/common/locales/global/en-PK')
      return
    }
    case 'en-PN': {
      import('@angular/common/locales/global/en-PN')
      return
    }
    case 'en-PR': {
      import('@angular/common/locales/global/en-PR')
      return
    }
    case 'en-PW': {
      import('@angular/common/locales/global/en-PW')
      return
    }
    case 'en-RW': {
      import('@angular/common/locales/global/en-RW')
      return
    }
    case 'en-SB': {
      import('@angular/common/locales/global/en-SB')
      return
    }
    case 'en-SC': {
      import('@angular/common/locales/global/en-SC')
      return
    }
    case 'en-SD': {
      import('@angular/common/locales/global/en-SD')
      return
    }
    case 'en-SE': {
      import('@angular/common/locales/global/en-SE')
      return
    }
    case 'en-SG': {
      import('@angular/common/locales/global/en-SG')
      return
    }
    case 'en-SH': {
      import('@angular/common/locales/global/en-SH')
      return
    }
    case 'en-SI': {
      import('@angular/common/locales/global/en-SI')
      return
    }
    case 'en-SL': {
      import('@angular/common/locales/global/en-SL')
      return
    }
    case 'en-SS': {
      import('@angular/common/locales/global/en-SS')
      return
    }
    case 'en-SX': {
      import('@angular/common/locales/global/en-SX')
      return
    }
    case 'en-SZ': {
      import('@angular/common/locales/global/en-SZ')
      return
    }
    case 'en-TC': {
      import('@angular/common/locales/global/en-TC')
      return
    }
    case 'en-TK': {
      import('@angular/common/locales/global/en-TK')
      return
    }
    case 'en-TO': {
      import('@angular/common/locales/global/en-TO')
      return
    }
    case 'en-TT': {
      import('@angular/common/locales/global/en-TT')
      return
    }
    case 'en-TV': {
      import('@angular/common/locales/global/en-TV')
      return
    }
    case 'en-TZ': {
      import('@angular/common/locales/global/en-TZ')
      return
    }
    case 'en-UG': {
      import('@angular/common/locales/global/en-UG')
      return
    }
    case 'en-UM': {
      import('@angular/common/locales/global/en-UM')
      return
    }
    case 'en-VC': {
      import('@angular/common/locales/global/en-VC')
      return
    }
    case 'en-VG': {
      import('@angular/common/locales/global/en-VG')
      return
    }
    case 'en-VI': {
      import('@angular/common/locales/global/en-VI')
      return
    }
    case 'en-VU': {
      import('@angular/common/locales/global/en-VU')
      return
    }
    case 'en-WS': {
      import('@angular/common/locales/global/en-WS')
      return
    }
    case 'en-ZA': {
      import('@angular/common/locales/global/en-ZA')
      return
    }
    case 'en-ZM': {
      import('@angular/common/locales/global/en-ZM')
      return
    }
    case 'en-ZW': {
      import('@angular/common/locales/global/en-ZW')
      return
    }
    case 'eo': {
      import('@angular/common/locales/global/eo')
      return
    }
    case 'es-419': {
      import('@angular/common/locales/global/es-419')
      return
    }
    case 'es-AR': {
      import('@angular/common/locales/global/es-AR')
      return
    }
    case 'es-BO': {
      import('@angular/common/locales/global/es-BO')
      return
    }
    case 'es-BR': {
      import('@angular/common/locales/global/es-BR')
      return
    }
    case 'es-BZ': {
      import('@angular/common/locales/global/es-BZ')
      return
    }
    case 'es-CL': {
      import('@angular/common/locales/global/es-CL')
      return
    }
    case 'es-CO': {
      import('@angular/common/locales/global/es-CO')
      return
    }
    case 'es-CR': {
      import('@angular/common/locales/global/es-CR')
      return
    }
    case 'es-CU': {
      import('@angular/common/locales/global/es-CU')
      return
    }
    case 'es-DO': {
      import('@angular/common/locales/global/es-DO')
      return
    }
    case 'es-EA': {
      import('@angular/common/locales/global/es-EA')
      return
    }
    case 'es-EC': {
      import('@angular/common/locales/global/es-EC')
      return
    }
    case 'es-GQ': {
      import('@angular/common/locales/global/es-GQ')
      return
    }
    case 'es-GT': {
      import('@angular/common/locales/global/es-GT')
      return
    }
    case 'es-HN': {
      import('@angular/common/locales/global/es-HN')
      return
    }
    case 'es-IC': {
      import('@angular/common/locales/global/es-IC')
      return
    }
    case 'es': {
      import('@angular/common/locales/global/es')
      return
    }
    case 'es-MX': {
      import('@angular/common/locales/global/es-MX')
      return
    }
    case 'es-NI': {
      import('@angular/common/locales/global/es-NI')
      return
    }
    case 'es-PA': {
      import('@angular/common/locales/global/es-PA')
      return
    }
    case 'es-PE': {
      import('@angular/common/locales/global/es-PE')
      return
    }
    case 'es-PH': {
      import('@angular/common/locales/global/es-PH')
      return
    }
    case 'es-PR': {
      import('@angular/common/locales/global/es-PR')
      return
    }
    case 'es-PY': {
      import('@angular/common/locales/global/es-PY')
      return
    }
    case 'es-SV': {
      import('@angular/common/locales/global/es-SV')
      return
    }
    case 'es-US': {
      import('@angular/common/locales/global/es-US')
      return
    }
    case 'es-UY': {
      import('@angular/common/locales/global/es-UY')
      return
    }
    case 'es-VE': {
      import('@angular/common/locales/global/es-VE')
      return
    }
    case 'et': {
      import('@angular/common/locales/global/et')
      return
    }
    case 'eu': {
      import('@angular/common/locales/global/eu')
      return
    }
    case 'ewo': {
      import('@angular/common/locales/global/ewo')
      return
    }
    case 'fa-AF': {
      import('@angular/common/locales/global/fa-AF')
      return
    }
    case 'fa': {
      import('@angular/common/locales/global/fa')
      return
    }
    case 'ff-Adlm-BF': {
      import('@angular/common/locales/global/ff-Adlm-BF')
      return
    }
    case 'ff-Adlm-CM': {
      import('@angular/common/locales/global/ff-Adlm-CM')
      return
    }
    case 'ff-Adlm-GH': {
      import('@angular/common/locales/global/ff-Adlm-GH')
      return
    }
    case 'ff-Adlm-GM': {
      import('@angular/common/locales/global/ff-Adlm-GM')
      return
    }
    case 'ff-Adlm-GW': {
      import('@angular/common/locales/global/ff-Adlm-GW')
      return
    }
    case 'ff-Adlm': {
      import('@angular/common/locales/global/ff-Adlm')
      return
    }
    case 'ff-Adlm-LR': {
      import('@angular/common/locales/global/ff-Adlm-LR')
      return
    }
    case 'ff-Adlm-MR': {
      import('@angular/common/locales/global/ff-Adlm-MR')
      return
    }
    case 'ff-Adlm-NE': {
      import('@angular/common/locales/global/ff-Adlm-NE')
      return
    }
    case 'ff-Adlm-NG': {
      import('@angular/common/locales/global/ff-Adlm-NG')
      return
    }
    case 'ff-Adlm-SL': {
      import('@angular/common/locales/global/ff-Adlm-SL')
      return
    }
    case 'ff-Adlm-SN': {
      import('@angular/common/locales/global/ff-Adlm-SN')
      return
    }
    case 'ff-CM': {
      import('@angular/common/locales/global/ff-CM')
      return
    }
    case 'ff-GN': {
      import('@angular/common/locales/global/ff-GN')
      return
    }
    case 'ff': {
      import('@angular/common/locales/global/ff')
      return
    }
    case 'ff-Latn-BF': {
      import('@angular/common/locales/global/ff-Latn-BF')
      return
    }
    case 'ff-Latn-CM': {
      import('@angular/common/locales/global/ff-Latn-CM')
      return
    }
    case 'ff-Latn-GH': {
      import('@angular/common/locales/global/ff-Latn-GH')
      return
    }
    case 'ff-Latn-GM': {
      import('@angular/common/locales/global/ff-Latn-GM')
      return
    }
    case 'ff-Latn-GN': {
      import('@angular/common/locales/global/ff-Latn-GN')
      return
    }
    case 'ff-Latn-GW': {
      import('@angular/common/locales/global/ff-Latn-GW')
      return
    }
    case 'ff-Latn': {
      import('@angular/common/locales/global/ff-Latn')
      return
    }
    case 'ff-Latn-LR': {
      import('@angular/common/locales/global/ff-Latn-LR')
      return
    }
    case 'ff-Latn-MR': {
      import('@angular/common/locales/global/ff-Latn-MR')
      return
    }
    case 'ff-Latn-NE': {
      import('@angular/common/locales/global/ff-Latn-NE')
      return
    }
    case 'ff-Latn-NG': {
      import('@angular/common/locales/global/ff-Latn-NG')
      return
    }
    case 'ff-Latn-SL': {
      import('@angular/common/locales/global/ff-Latn-SL')
      return
    }
    case 'ff-MR': {
      import('@angular/common/locales/global/ff-MR')
      return
    }
    case 'fi': {
      import('@angular/common/locales/global/fi')
      return
    }
    case 'fil': {
      import('@angular/common/locales/global/fil')
      return
    }
    case 'fo-DK': {
      import('@angular/common/locales/global/fo-DK')
      return
    }
    case 'fo': {
      import('@angular/common/locales/global/fo')
      return
    }
    case 'fr-BE': {
      import('@angular/common/locales/global/fr-BE')
      return
    }
    case 'fr-BF': {
      import('@angular/common/locales/global/fr-BF')
      return
    }
    case 'fr-BI': {
      import('@angular/common/locales/global/fr-BI')
      return
    }
    case 'fr-BJ': {
      import('@angular/common/locales/global/fr-BJ')
      return
    }
    case 'fr-BL': {
      import('@angular/common/locales/global/fr-BL')
      return
    }
    case 'fr-CA': {
      import('@angular/common/locales/global/fr-CA')
      return
    }
    case 'fr-CD': {
      import('@angular/common/locales/global/fr-CD')
      return
    }
    case 'fr-CF': {
      import('@angular/common/locales/global/fr-CF')
      return
    }
    case 'fr-CG': {
      import('@angular/common/locales/global/fr-CG')
      return
    }
    case 'fr-CH': {
      import('@angular/common/locales/global/fr-CH')
      return
    }
    case 'fr-CI': {
      import('@angular/common/locales/global/fr-CI')
      return
    }
    case 'fr-CM': {
      import('@angular/common/locales/global/fr-CM')
      return
    }
    case 'fr-DJ': {
      import('@angular/common/locales/global/fr-DJ')
      return
    }
    case 'fr-DZ': {
      import('@angular/common/locales/global/fr-DZ')
      return
    }
    case 'fr-GA': {
      import('@angular/common/locales/global/fr-GA')
      return
    }
    case 'fr-GF': {
      import('@angular/common/locales/global/fr-GF')
      return
    }
    case 'fr-GN': {
      import('@angular/common/locales/global/fr-GN')
      return
    }
    case 'fr-GP': {
      import('@angular/common/locales/global/fr-GP')
      return
    }
    case 'fr-GQ': {
      import('@angular/common/locales/global/fr-GQ')
      return
    }
    case 'fr-HT': {
      import('@angular/common/locales/global/fr-HT')
      return
    }
    case 'fr': {
      import('@angular/common/locales/global/fr')
      return
    }
    case 'fr-KM': {
      import('@angular/common/locales/global/fr-KM')
      return
    }
    case 'fr-LU': {
      import('@angular/common/locales/global/fr-LU')
      return
    }
    case 'fr-MA': {
      import('@angular/common/locales/global/fr-MA')
      return
    }
    case 'fr-MC': {
      import('@angular/common/locales/global/fr-MC')
      return
    }
    case 'fr-MF': {
      import('@angular/common/locales/global/fr-MF')
      return
    }
    case 'fr-MG': {
      import('@angular/common/locales/global/fr-MG')
      return
    }
    case 'fr-ML': {
      import('@angular/common/locales/global/fr-ML')
      return
    }
    case 'fr-MQ': {
      import('@angular/common/locales/global/fr-MQ')
      return
    }
    case 'fr-MR': {
      import('@angular/common/locales/global/fr-MR')
      return
    }
    case 'fr-MU': {
      import('@angular/common/locales/global/fr-MU')
      return
    }
    case 'fr-NC': {
      import('@angular/common/locales/global/fr-NC')
      return
    }
    case 'fr-NE': {
      import('@angular/common/locales/global/fr-NE')
      return
    }
    case 'fr-PF': {
      import('@angular/common/locales/global/fr-PF')
      return
    }
    case 'fr-PM': {
      import('@angular/common/locales/global/fr-PM')
      return
    }
    case 'fr-RE': {
      import('@angular/common/locales/global/fr-RE')
      return
    }
    case 'fr-RW': {
      import('@angular/common/locales/global/fr-RW')
      return
    }
    case 'fr-SC': {
      import('@angular/common/locales/global/fr-SC')
      return
    }
    case 'fr-SN': {
      import('@angular/common/locales/global/fr-SN')
      return
    }
    case 'fr-SY': {
      import('@angular/common/locales/global/fr-SY')
      return
    }
    case 'fr-TD': {
      import('@angular/common/locales/global/fr-TD')
      return
    }
    case 'fr-TG': {
      import('@angular/common/locales/global/fr-TG')
      return
    }
    case 'fr-TN': {
      import('@angular/common/locales/global/fr-TN')
      return
    }
    case 'fr-VU': {
      import('@angular/common/locales/global/fr-VU')
      return
    }
    case 'fr-WF': {
      import('@angular/common/locales/global/fr-WF')
      return
    }
    case 'fr-YT': {
      import('@angular/common/locales/global/fr-YT')
      return
    }
    case 'fur': {
      import('@angular/common/locales/global/fur')
      return
    }
    case 'fy': {
      import('@angular/common/locales/global/fy')
      return
    }
    case 'ga-GB': {
      import('@angular/common/locales/global/ga-GB')
      return
    }
    case 'ga': {
      import('@angular/common/locales/global/ga')
      return
    }
    case 'gd': {
      import('@angular/common/locales/global/gd')
      return
    }
    case 'gl': {
      import('@angular/common/locales/global/gl')
      return
    }
    case 'gsw-FR': {
      import('@angular/common/locales/global/gsw-FR')
      return
    }
    case 'gsw': {
      import('@angular/common/locales/global/gsw')
      return
    }
    case 'gsw-LI': {
      import('@angular/common/locales/global/gsw-LI')
      return
    }
    case 'gu': {
      import('@angular/common/locales/global/gu')
      return
    }
    case 'guz': {
      import('@angular/common/locales/global/guz')
      return
    }
    case 'gv': {
      import('@angular/common/locales/global/gv')
      return
    }
    case 'ha-GH': {
      import('@angular/common/locales/global/ha-GH')
      return
    }
    case 'ha': {
      import('@angular/common/locales/global/ha')
      return
    }
    case 'ha-NE': {
      import('@angular/common/locales/global/ha-NE')
      return
    }
    case 'haw': {
      import('@angular/common/locales/global/haw')
      return
    }
    case 'he': {
      import('@angular/common/locales/global/he')
      return
    }
    case 'hi': {
      import('@angular/common/locales/global/hi')
      return
    }
    case 'hr-BA': {
      import('@angular/common/locales/global/hr-BA')
      return
    }
    case 'hr': {
      import('@angular/common/locales/global/hr')
      return
    }
    case 'hsb': {
      import('@angular/common/locales/global/hsb')
      return
    }
    case 'hu': {
      import('@angular/common/locales/global/hu')
      return
    }
    case 'hy': {
      import('@angular/common/locales/global/hy')
      return
    }
    case 'ia': {
      import('@angular/common/locales/global/ia')
      return
    }
    case 'id': {
      import('@angular/common/locales/global/id')
      return
    }
    case 'ig': {
      import('@angular/common/locales/global/ig')
      return
    }
    case 'ii': {
      import('@angular/common/locales/global/ii')
      return
    }
    case 'is': {
      import('@angular/common/locales/global/is')
      return
    }
    case 'it-CH': {
      import('@angular/common/locales/global/it-CH')
      return
    }
    case 'it': {
      import('@angular/common/locales/global/it')
      return
    }
    case 'it-SM': {
      import('@angular/common/locales/global/it-SM')
      return
    }
    case 'it-VA': {
      import('@angular/common/locales/global/it-VA')
      return
    }
    case 'ja': {
      import('@angular/common/locales/global/ja')
      return
    }
    case 'jgo': {
      import('@angular/common/locales/global/jgo')
      return
    }
    case 'jmc': {
      import('@angular/common/locales/global/jmc')
      return
    }
    case 'jv': {
      import('@angular/common/locales/global/jv')
      return
    }
    case 'kab': {
      import('@angular/common/locales/global/kab')
      return
    }
    case 'ka': {
      import('@angular/common/locales/global/ka')
      return
    }
    case 'kam': {
      import('@angular/common/locales/global/kam')
      return
    }
    case 'kde': {
      import('@angular/common/locales/global/kde')
      return
    }
    case 'kea': {
      import('@angular/common/locales/global/kea')
      return
    }
    case 'khq': {
      import('@angular/common/locales/global/khq')
      return
    }
    case 'ki': {
      import('@angular/common/locales/global/ki')
      return
    }
    case 'kkj': {
      import('@angular/common/locales/global/kkj')
      return
    }
    case 'kk': {
      import('@angular/common/locales/global/kk')
      return
    }
    case 'kl': {
      import('@angular/common/locales/global/kl')
      return
    }
    case 'kln': {
      import('@angular/common/locales/global/kln')
      return
    }
    case 'km': {
      import('@angular/common/locales/global/km')
      return
    }
    case 'kn': {
      import('@angular/common/locales/global/kn')
      return
    }
    case 'ko': {
      import('@angular/common/locales/global/ko')
      return
    }
    case 'kok': {
      import('@angular/common/locales/global/kok')
      return
    }
    case 'ko-KP': {
      import('@angular/common/locales/global/ko-KP')
      return
    }
    case 'ks-Arab': {
      import('@angular/common/locales/global/ks-Arab')
      return
    }
    case 'ksb': {
      import('@angular/common/locales/global/ksb')
      return
    }
    case 'ksf': {
      import('@angular/common/locales/global/ksf')
      return
    }
    case 'ksh': {
      import('@angular/common/locales/global/ksh')
      return
    }
    case 'ks': {
      import('@angular/common/locales/global/ks')
      return
    }
    case 'ku': {
      import('@angular/common/locales/global/ku')
      return
    }
    case 'kw': {
      import('@angular/common/locales/global/kw')
      return
    }
    case 'ky': {
      import('@angular/common/locales/global/ky')
      return
    }
    case 'lag': {
      import('@angular/common/locales/global/lag')
      return
    }
    case 'lb': {
      import('@angular/common/locales/global/lb')
      return
    }
    case 'lg': {
      import('@angular/common/locales/global/lg')
      return
    }
    case 'lkt': {
      import('@angular/common/locales/global/lkt')
      return
    }
    case 'ln-AO': {
      import('@angular/common/locales/global/ln-AO')
      return
    }
    case 'ln-CF': {
      import('@angular/common/locales/global/ln-CF')
      return
    }
    case 'ln-CG': {
      import('@angular/common/locales/global/ln-CG')
      return
    }
    case 'ln': {
      import('@angular/common/locales/global/ln')
      return
    }
    case 'lo': {
      import('@angular/common/locales/global/lo')
      return
    }
    case 'lrc-IQ': {
      import('@angular/common/locales/global/lrc-IQ')
      return
    }
    case 'lrc': {
      import('@angular/common/locales/global/lrc')
      return
    }
    case 'lt': {
      import('@angular/common/locales/global/lt')
      return
    }
    case 'lu': {
      import('@angular/common/locales/global/lu')
      return
    }
    case 'luo': {
      import('@angular/common/locales/global/luo')
      return
    }
    case 'luy': {
      import('@angular/common/locales/global/luy')
      return
    }
    case 'lv': {
      import('@angular/common/locales/global/lv')
      return
    }
    case 'mai': {
      import('@angular/common/locales/global/mai')
      return
    }
    case 'mas': {
      import('@angular/common/locales/global/mas')
      return
    }
    case 'mas-TZ': {
      import('@angular/common/locales/global/mas-TZ')
      return
    }
    case 'mer': {
      import('@angular/common/locales/global/mer')
      return
    }
    case 'mfe': {
      import('@angular/common/locales/global/mfe')
      return
    }
    case 'mgh': {
      import('@angular/common/locales/global/mgh')
      return
    }
    case 'mg': {
      import('@angular/common/locales/global/mg')
      return
    }
    case 'mgo': {
      import('@angular/common/locales/global/mgo')
      return
    }
    case 'mi': {
      import('@angular/common/locales/global/mi')
      return
    }
    case 'mk': {
      import('@angular/common/locales/global/mk')
      return
    }
    case 'ml': {
      import('@angular/common/locales/global/ml')
      return
    }
    case 'mni-Beng': {
      import('@angular/common/locales/global/mni-Beng')
      return
    }
    case 'mni': {
      import('@angular/common/locales/global/mni')
      return
    }
    case 'mn': {
      import('@angular/common/locales/global/mn')
      return
    }
    case 'mr': {
      import('@angular/common/locales/global/mr')
      return
    }
    case 'ms-BN': {
      import('@angular/common/locales/global/ms-BN')
      return
    }
    case 'ms-ID': {
      import('@angular/common/locales/global/ms-ID')
      return
    }
    case 'ms': {
      import('@angular/common/locales/global/ms')
      return
    }
    case 'ms-SG': {
      import('@angular/common/locales/global/ms-SG')
      return
    }
    case 'mt': {
      import('@angular/common/locales/global/mt')
      return
    }
    case 'mua': {
      import('@angular/common/locales/global/mua')
      return
    }
    case 'my': {
      import('@angular/common/locales/global/my')
      return
    }
    case 'mzn': {
      import('@angular/common/locales/global/mzn')
      return
    }
    case 'naq': {
      import('@angular/common/locales/global/naq')
      return
    }
    case 'nb': {
      import('@angular/common/locales/global/nb')
      return
    }
    case 'nb-SJ': {
      import('@angular/common/locales/global/nb-SJ')
      return
    }
    case 'nd': {
      import('@angular/common/locales/global/nd')
      return
    }
    case 'nds': {
      import('@angular/common/locales/global/nds')
      return
    }
    case 'nds-NL': {
      import('@angular/common/locales/global/nds-NL')
      return
    }
    case 'ne-IN': {
      import('@angular/common/locales/global/ne-IN')
      return
    }
    case 'ne': {
      import('@angular/common/locales/global/ne')
      return
    }
    case 'nl-AW': {
      import('@angular/common/locales/global/nl-AW')
      return
    }
    case 'nl-BE': {
      import('@angular/common/locales/global/nl-BE')
      return
    }
    case 'nl-BQ': {
      import('@angular/common/locales/global/nl-BQ')
      return
    }
    case 'nl-CW': {
      import('@angular/common/locales/global/nl-CW')
      return
    }
    case 'nl': {
      import('@angular/common/locales/global/nl')
      return
    }
    case 'nl-SR': {
      import('@angular/common/locales/global/nl-SR')
      return
    }
    case 'nl-SX': {
      import('@angular/common/locales/global/nl-SX')
      return
    }
    case 'nmg': {
      import('@angular/common/locales/global/nmg')
      return
    }
    case 'nnh': {
      import('@angular/common/locales/global/nnh')
      return
    }
    case 'nn': {
      import('@angular/common/locales/global/nn')
      return
    }
    case 'no': {
      import('@angular/common/locales/global/no')
      return
    }
    case 'nus': {
      import('@angular/common/locales/global/nus')
      return
    }
    case 'nyn': {
      import('@angular/common/locales/global/nyn')
      return
    }
    case 'om': {
      import('@angular/common/locales/global/om')
      return
    }
    case 'om-KE': {
      import('@angular/common/locales/global/om-KE')
      return
    }
    case 'or': {
      import('@angular/common/locales/global/or')
      return
    }
    case 'os': {
      import('@angular/common/locales/global/os')
      return
    }
    case 'os-RU': {
      import('@angular/common/locales/global/os-RU')
      return
    }
    case 'pa-Arab': {
      import('@angular/common/locales/global/pa-Arab')
      return
    }
    case 'pa-Guru': {
      import('@angular/common/locales/global/pa-Guru')
      return
    }
    case 'pa': {
      import('@angular/common/locales/global/pa')
      return
    }
    case 'pcm': {
      import('@angular/common/locales/global/pcm')
      return
    }
    case 'pl': {
      import('@angular/common/locales/global/pl')
      return
    }
    case 'ps': {
      import('@angular/common/locales/global/ps')
      return
    }
    case 'ps-PK': {
      import('@angular/common/locales/global/ps-PK')
      return
    }
    case 'pt-AO': {
      import('@angular/common/locales/global/pt-AO')
      return
    }
    case 'pt-CH': {
      import('@angular/common/locales/global/pt-CH')
      return
    }
    case 'pt-CV': {
      import('@angular/common/locales/global/pt-CV')
      return
    }
    case 'pt-GQ': {
      import('@angular/common/locales/global/pt-GQ')
      return
    }
    case 'pt-GW': {
      import('@angular/common/locales/global/pt-GW')
      return
    }
    case 'pt': {
      import('@angular/common/locales/global/pt')
      return
    }
    case 'pt-LU': {
      import('@angular/common/locales/global/pt-LU')
      return
    }
    case 'pt-MO': {
      import('@angular/common/locales/global/pt-MO')
      return
    }
    case 'pt-MZ': {
      import('@angular/common/locales/global/pt-MZ')
      return
    }
    case 'pt-PT': {
      import('@angular/common/locales/global/pt-PT')
      return
    }
    case 'pt-ST': {
      import('@angular/common/locales/global/pt-ST')
      return
    }
    case 'pt-TL': {
      import('@angular/common/locales/global/pt-TL')
      return
    }
    case 'qu-BO': {
      import('@angular/common/locales/global/qu-BO')
      return
    }
    case 'qu-EC': {
      import('@angular/common/locales/global/qu-EC')
      return
    }
    case 'qu': {
      import('@angular/common/locales/global/qu')
      return
    }
    case 'rm': {
      import('@angular/common/locales/global/rm')
      return
    }
    case 'rn': {
      import('@angular/common/locales/global/rn')
      return
    }
    case 'rof': {
      import('@angular/common/locales/global/rof')
      return
    }
    case 'ro': {
      import('@angular/common/locales/global/ro')
      return
    }
    case 'ro-MD': {
      import('@angular/common/locales/global/ro-MD')
      return
    }
    case 'ru-BY': {
      import('@angular/common/locales/global/ru-BY')
      return
    }
    case 'ru': {
      import('@angular/common/locales/global/ru')
      return
    }
    case 'ru-KG': {
      import('@angular/common/locales/global/ru-KG')
      return
    }
    case 'ru-KZ': {
      import('@angular/common/locales/global/ru-KZ')
      return
    }
    case 'ru-MD': {
      import('@angular/common/locales/global/ru-MD')
      return
    }
    case 'ru-UA': {
      import('@angular/common/locales/global/ru-UA')
      return
    }
    case 'rw': {
      import('@angular/common/locales/global/rw')
      return
    }
    case 'rwk': {
      import('@angular/common/locales/global/rwk')
      return
    }
    case 'sah': {
      import('@angular/common/locales/global/sah')
      return
    }
    case 'sa': {
      import('@angular/common/locales/global/sa')
      return
    }
    case 'saq': {
      import('@angular/common/locales/global/saq')
      return
    }
    case 'sat': {
      import('@angular/common/locales/global/sat')
      return
    }
    case 'sat-Olck': {
      import('@angular/common/locales/global/sat-Olck')
      return
    }
    case 'sbp': {
      import('@angular/common/locales/global/sbp')
      return
    }
    case 'sd-Arab': {
      import('@angular/common/locales/global/sd-Arab')
      return
    }
    case 'sd-Deva': {
      import('@angular/common/locales/global/sd-Deva')
      return
    }
    case 'sd': {
      import('@angular/common/locales/global/sd')
      return
    }
    case 'se-FI': {
      import('@angular/common/locales/global/se-FI')
      return
    }
    case 'seh': {
      import('@angular/common/locales/global/seh')
      return
    }
    case 'se': {
      import('@angular/common/locales/global/se')
      return
    }
    case 'se-SE': {
      import('@angular/common/locales/global/se-SE')
      return
    }
    case 'ses': {
      import('@angular/common/locales/global/ses')
      return
    }
    case 'sg': {
      import('@angular/common/locales/global/sg')
      return
    }
    case 'shi': {
      import('@angular/common/locales/global/shi')
      return
    }
    case 'shi-Latn': {
      import('@angular/common/locales/global/shi-Latn')
      return
    }
    case 'shi-Tfng': {
      import('@angular/common/locales/global/shi-Tfng')
      return
    }
    case 'si': {
      import('@angular/common/locales/global/si')
      return
    }
    case 'sk': {
      import('@angular/common/locales/global/sk')
      return
    }
    case 'sl': {
      import('@angular/common/locales/global/sl')
      return
    }
    case 'smn': {
      import('@angular/common/locales/global/smn')
      return
    }
    case 'sn': {
      import('@angular/common/locales/global/sn')
      return
    }
    case 'so-DJ': {
      import('@angular/common/locales/global/so-DJ')
      return
    }
    case 'so-ET': {
      import('@angular/common/locales/global/so-ET')
      return
    }
    case 'so': {
      import('@angular/common/locales/global/so')
      return
    }
    case 'so-KE': {
      import('@angular/common/locales/global/so-KE')
      return
    }
    case 'sq': {
      import('@angular/common/locales/global/sq')
      return
    }
    case 'sq-MK': {
      import('@angular/common/locales/global/sq-MK')
      return
    }
    case 'sq-XK': {
      import('@angular/common/locales/global/sq-XK')
      return
    }
    case 'sr-Cyrl-BA': {
      import('@angular/common/locales/global/sr-Cyrl-BA')
      return
    }
    case 'sr-Cyrl': {
      import('@angular/common/locales/global/sr-Cyrl')
      return
    }
    case 'sr-Cyrl-ME': {
      import('@angular/common/locales/global/sr-Cyrl-ME')
      return
    }
    case 'sr-Cyrl-XK': {
      import('@angular/common/locales/global/sr-Cyrl-XK')
      return
    }
    case 'sr': {
      import('@angular/common/locales/global/sr')
      return
    }
    case 'sr-Latn-BA': {
      import('@angular/common/locales/global/sr-Latn-BA')
      return
    }
    case 'sr-Latn': {
      import('@angular/common/locales/global/sr-Latn')
      return
    }
    case 'sr-Latn-ME': {
      import('@angular/common/locales/global/sr-Latn-ME')
      return
    }
    case 'sr-Latn-XK': {
      import('@angular/common/locales/global/sr-Latn-XK')
      return
    }
    case 'su': {
      import('@angular/common/locales/global/su')
      return
    }
    case 'su-Latn': {
      import('@angular/common/locales/global/su-Latn')
      return
    }
    case 'sv-AX': {
      import('@angular/common/locales/global/sv-AX')
      return
    }
    case 'sv-FI': {
      import('@angular/common/locales/global/sv-FI')
      return
    }
    case 'sv': {
      import('@angular/common/locales/global/sv')
      return
    }
    case 'sw-CD': {
      import('@angular/common/locales/global/sw-CD')
      return
    }
    case 'sw': {
      import('@angular/common/locales/global/sw')
      return
    }
    case 'sw-KE': {
      import('@angular/common/locales/global/sw-KE')
      return
    }
    case 'sw-UG': {
      import('@angular/common/locales/global/sw-UG')
      return
    }
    case 'ta': {
      import('@angular/common/locales/global/ta')
      return
    }
    case 'ta-LK': {
      import('@angular/common/locales/global/ta-LK')
      return
    }
    case 'ta-MY': {
      import('@angular/common/locales/global/ta-MY')
      return
    }
    case 'ta-SG': {
      import('@angular/common/locales/global/ta-SG')
      return
    }
    case 'te': {
      import('@angular/common/locales/global/te')
      return
    }
    case 'teo': {
      import('@angular/common/locales/global/teo')
      return
    }
    case 'teo-KE': {
      import('@angular/common/locales/global/teo-KE')
      return
    }
    case 'tg': {
      import('@angular/common/locales/global/tg')
      return
    }
    case 'th': {
      import('@angular/common/locales/global/th')
      return
    }
    case 'ti-ER': {
      import('@angular/common/locales/global/ti-ER')
      return
    }
    case 'ti': {
      import('@angular/common/locales/global/ti')
      return
    }
    case 'tk': {
      import('@angular/common/locales/global/tk')
      return
    }
    case 'to': {
      import('@angular/common/locales/global/to')
      return
    }
    case 'tr-CY': {
      import('@angular/common/locales/global/tr-CY')
      return
    }
    case 'tr': {
      import('@angular/common/locales/global/tr')
      return
    }
    case 'tt': {
      import('@angular/common/locales/global/tt')
      return
    }
    case 'twq': {
      import('@angular/common/locales/global/twq')
      return
    }
    case 'tzm': {
      import('@angular/common/locales/global/tzm')
      return
    }
    case 'ug': {
      import('@angular/common/locales/global/ug')
      return
    }
    case 'uk': {
      import('@angular/common/locales/global/uk')
      return
    }
    case 'ur-IN': {
      import('@angular/common/locales/global/ur-IN')
      return
    }
    case 'ur': {
      import('@angular/common/locales/global/ur')
      return
    }
    case 'uz-Arab': {
      import('@angular/common/locales/global/uz-Arab')
      return
    }
    case 'uz-Cyrl': {
      import('@angular/common/locales/global/uz-Cyrl')
      return
    }
    case 'uz': {
      import('@angular/common/locales/global/uz')
      return
    }
    case 'uz-Latn': {
      import('@angular/common/locales/global/uz-Latn')
      return
    }
    case 'vai': {
      import('@angular/common/locales/global/vai')
      return
    }
    case 'vai-Latn': {
      import('@angular/common/locales/global/vai-Latn')
      return
    }
    case 'vai-Vaii': {
      import('@angular/common/locales/global/vai-Vaii')
      return
    }
    case 'vi': {
      import('@angular/common/locales/global/vi')
      return
    }
    case 'vun': {
      import('@angular/common/locales/global/vun')
      return
    }
    case 'wae': {
      import('@angular/common/locales/global/wae')
      return
    }
    case 'wo': {
      import('@angular/common/locales/global/wo')
      return
    }
    case 'xh': {
      import('@angular/common/locales/global/xh')
      return
    }
    case 'xog': {
      import('@angular/common/locales/global/xog')
      return
    }
    case 'yav': {
      import('@angular/common/locales/global/yav')
      return
    }
    case 'yi': {
      import('@angular/common/locales/global/yi')
      return
    }
    case 'yo-BJ': {
      import('@angular/common/locales/global/yo-BJ')
      return
    }
    case 'yo': {
      import('@angular/common/locales/global/yo')
      return
    }
    case 'yue-Hans': {
      import('@angular/common/locales/global/yue-Hans')
      return
    }
    case 'yue-Hant': {
      import('@angular/common/locales/global/yue-Hant')
      return
    }
    case 'yue': {
      import('@angular/common/locales/global/yue')
      return
    }
    case 'zgh': {
      import('@angular/common/locales/global/zgh')
      return
    }
    case 'zh-Hans-HK': {
      import('@angular/common/locales/global/zh-Hans-HK')
      return
    }
    case 'zh-Hans': {
      import('@angular/common/locales/global/zh-Hans')
      return
    }
    case 'zh-Hans-MO': {
      import('@angular/common/locales/global/zh-Hans-MO')
      return
    }
    case 'zh-Hans-SG': {
      import('@angular/common/locales/global/zh-Hans-SG')
      return
    }
    case 'zh-Hant-HK': {
      import('@angular/common/locales/global/zh-Hant-HK')
      return
    }
    case 'zh-Hant': {
      import('@angular/common/locales/global/zh-Hant')
      return
    }
    case 'zh-Hant-MO': {
      import('@angular/common/locales/global/zh-Hant-MO')
      return
    }
    case 'zh': {
      import('@angular/common/locales/global/zh')
      return
    }
    case 'zu': {
      import('@angular/common/locales/global/zu')
      return
    }
  }
}
